import PropTypes from 'prop-types';

export const ARTICLE_PROP_TYPES = PropTypes.shape({
  url: PropTypes.string,
  largeImage: PropTypes.string,
  smallImage: PropTypes.string,
  title: PropTypes.string,
  label: PropTypes.string,
  date: PropTypes.string,
  description: PropTypes.string,
});

export const ARTICLES_PROP_TYPES = PropTypes.arrayOf(ARTICLE_PROP_TYPES);

export const USER_AGENT_PROP_TYPES = PropTypes.shape({
  isMobile: PropTypes.bool.isRequired,
  isTablet: PropTypes.bool.isRequired,
  isDesktop: PropTypes.bool.isRequired,
});

export const RECENT_SEARCH_PROP_TYPES = PropTypes.arrayOf(
  PropTypes.shape({
    name: PropTypes.string.isRequired,
    detailText: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }),
);
